import { useEffect } from 'react';
import { kcdDatadogLogs } from '@kcd/app-utils/dist/browser';

import type { SendDefaultSettings } from '~/types/kakao';

/**
 * @docs https://developers.kakao.com/sdk/reference/js/release/Kakao.Share.html#.sendCustom
 * */

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Kakao: any;
  }
}

/**
 * @description Kakao SDK 초기화
 * - 필요한 시점에 호출하여 초기화 후 사용 권장
 * - TODO - 더 많은곳에서 사용된다면 script tag를 통해 초기화 고려
 * */
export function useInitializeKakao() {
  useEffect(() => {
    if (window.Kakao) return;

    const script = document.createElement('script');
    script.src = 'https://t1.kakaocdn.net/kakao_js_sdk/2.7.9/kakao.min.js';
    script.async = true;
    script.integrity =
      'sha384-JpLApTkB8lPskhVMhT+m5Ln8aHlnS0bsIexhaak0jOhAkMYedQoVghPfSpjNi9K1';
    script.crossOrigin = 'anonymous';

    script.onload = () => {
      try {
        window.Kakao.init(process.env.NEXT_PUBLIC_KAKAO_API_KEY);
        // eslint-disable-next-line no-console
        console.log('kakao initialized:', window.Kakao.isInitialized());
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('kakao initialize error:', error);
        kcdDatadogLogs.logger.error(
          'Kakao initialize error:',
          {},
          new Error(error as string),
        );
      }
    };
    document.body.appendChild(script);
  }, []);
}

/**
 * @description 카카오톡 공유하기
 * */
export function shareToKakao(settings: SendDefaultSettings) {
  if (!window.Kakao || !window.Kakao.isInitialized()) {
    throw new Error('카카오 스크립트가 설치되지 않았습니다.');
  }

  try {
    window.Kakao.Share.sendDefault(settings);
  } catch (error) {
    kcdDatadogLogs.logger.error(
      'Kakao Share Error :',
      {
        pageName:
          typeof window !== 'undefined' ? window.location.pathname : 'server',
      },
      new Error(error as string),
    );

    throw new Error(error as string);
  }
}
